<div #popup class=" no-select mat-dialog-edition-form mat-dialog">
    <div class="popup-header d-flex justify-content-between align-items-center">
        <h2 class="title mx-auto text-center w-100 fs-6">
            {{ isEdit ? ('USER.MODIFY_USER' | translate) : ('BUTTONS.NEW_USER' | translate) }}

        </h2>
        <button type="button" class="btn-close ms-auto p-2" data-bs-dismiss="modal" aria-label="Close"
         (click)="closeDialog()"></button>
    </div>

    <div class="popup-content">
        <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
            <div class="d-flex">
                <div class="col-6 input-container pe-2">
                    <div class="row-item-width-100 input-container">
                        <label class="form-label text-center d-block" for="firstName">
                            {{ 'FORM.NAME' | translate }} <span class="text-danger">*</span>
                            <div *ngIf="isFieldInvalid('firstName')" class="text-danger error-text">
                                {{ getFieldErrorMessage('firstName') }}
                            </div>
                        </label>
                        <input class="form-control" id="firstName" type="text" formControlName="firstName"
                            [placeholder]="'FORM.NAME' | translate" required />
                    </div>
                </div>
                
                <div class="col-6 input-container ps-2">
                    <div class="row-item-width-100 input-container" style="flex: 1;">
                    <label class="form-label text-center d-block" for="lastName">
                        {{ 'FORM.LAST_NAME' | translate }} <span class="text-danger">*</span>
                        <div *ngIf="isFieldInvalid('lastName')" class="text-danger error-text">
                            {{ getFieldErrorMessage('lastName') }}
                        </div>
                    </label>
                    <input class="form-control" id="lastName" type="text" formControlName="lastName"
                        [placeholder]="'FORM.LAST_NAME' | translate" required />
                </div>
                </div>
              
            </div>

            <div class="d-flex">
                <div class="col-6 input-container pe-2">
                    <div class="row-item-width-100 input-container" style="flex: 1;">
                    <label class="form-label text-center d-block" for="email">
                        {{ 'FORM.MAIL' | translate }}<span class="text-danger">*</span>
                        <div *ngIf="isFieldInvalid('email')" class="text-danger error-text">
                            {{ getFieldErrorMessage('email') }}
                        </div>
                    </label>
                    <input class="form-control" id="email" type="text" formControlName="email"
                        [placeholder]="'FORM.MAIL' | translate" />
                </div>
                </div>
                <div class="col-6 input-container ps-2">
                    <div class="row-item-width-100 input-container" style="flex: 1;">
                        <label class="form-label text-center d-block" for="language">
                            {{ 'FORM.LANGUAGE' | translate }} <span class="text-danger">*</span>
                            <div *ngIf="isFieldInvalid('language')" class="text-danger error-text">
                                {{ getFieldErrorMessage('language') }}
                            </div>
                        </label>
                        <ng-select [items]="languages" bindLabel="nom" bindValue="nom" formControlName="language"
                            id="language" [placeholder]="'PLACEHOLDERS.SELECT_LANGUAGE' | translate" [clearable]="true"
                            required>
                        </ng-select>
                    </div>
                </div>

            </div>

            <div class="d-flex">
                <div class="col-6 input-container pe-2">
                    <div class="row-item-width-100 input-container" style="flex: 1;">
                        <label class="form-label text-center d-block" for="role">
                            {{ 'FORM.ROLE' | translate }} <span class="text-danger">*</span>
                            <div *ngIf="isFieldInvalid('role')" class="text-danger error-text">
                                {{ getFieldErrorMessage('role') }}
                            </div>
                        </label>
                        <ng-select [items]="roles" bindLabel="role" bindValue="role" formControlName="role" id="role"
                            [multiple]="true" [placeholder]="'PLACEHOLDERS.SELECT_ROLE' | translate" [clearable]="true"
                            required>
                        </ng-select>
                    </div>
                </div>

                <div class="mb-2" style="flex: 1;">
                    <label class="form-label text-center d-block" for="companyName">
                        {{ 'FORM.COMPANY' | translate }} <span class="text-danger">*</span>
                        <div *ngIf="isFieldInvalid('companyName')" class="text-danger error-text">
                            {{ getFieldErrorMessage('companyName') }}
                        </div>
                    </label>
                    <ng-select [items]="companies" bindLabel="name" bindValue="name" formControlName="companyName"
                        id="companyName" [placeholder]="'PLACEHOLDERS.SELECT_COMPANY' | translate" [clearable]="true"
                        required>
                    </ng-select>
                </div>
            </div>

            <div class="d-flex justify-content-between align-items-start mb-2">
                <div class="mb-2 me-3" style="flex: 1;">
                    <label class="form-label text-center d-block" for="mainOrganization">
                        {{ 'FORM.MAIN_ORGANIZATION' | translate }}
                    </label>
                    <ng-select [items]="organizations" bindLabel="name" bindValue="name"
                        formControlName="mainOrganization" id="mainOrganization"
                        [placeholder]="'PLACEHOLDERS.SELECT_ORGANIZATION' | translate" [clearable]="true"
                        [disabled]="true">
                    </ng-select>
                </div>
                <div class="mb-2" style="flex: 1;">
                    <label class="form-label text-center d-block" for="secondaryOrganizations">
                        {{ 'FORM.SECONDARY_ORGANIZATIONS' | translate }}
                    </label>
                    <ng-select [items]="organizations" bindLabel="name" bindValue="name"
                        formControlName="secondaryOrganizations" id="secondaryOrganizations" [multiple]="true"
                        [placeholder]="'PLACEHOLDERS.SELECT_ORGANIZATION' | translate" [clearable]="true"
                        [disabled]="true">
                    </ng-select>
                </div>
            </div>

            <div class="d-flex justify-content-between align-items-start mb-2">
                <div class="mb-2 me-3" style="flex: 1;">
                    <label class="form-label text-center d-block" for="areas">
                        {{ 'FORM.AREAS' | translate }} <span class="text-danger">*</span>
                        <div *ngIf="isFieldInvalid('areas')" class="text-danger error-text">
                            {{ getFieldErrorMessage('areas') }}
                        </div>
                    </label>
                    <ng-select [items]="areas" bindLabel="nom" bindValue="regionId" formControlName="areas" id="areas"
                        [multiple]="true" [placeholder]="'PLACEHOLDERS.SELECT_AREA' | translate" [clearable]="true"
                        required>
                    </ng-select>
                </div>
                <div class="mb-2 toggle-container" style="flex: 1;">
                    <div class="toggle-wrapper">
                        <label class="form-check-label me-2" for="adminAreas">
                            {{ 'FORM.ADMIN_AREAS' | translate }}
                        </label>
                        <label class="switch">
                            <input type="checkbox" id="adminAreas" formControlName="adminAreas" />
                            <span class="slider round"></span>
                        </label>
                    </div>
                </div>
            </div>

            <div class="d-flex justify-content-between align-items-start mb-2">
                <div class="mb-2 me-3" style="flex: 1;">
                    <label class="form-label text-center d-block" for="sites">
                        {{ 'FORM.SITES' | translate }} <span class="text-danger">*</span>
                        <div *ngIf="isFieldInvalid('sites')" class="text-danger error-text">
                            {{ getFieldErrorMessage('sites') }}
                        </div>
                    </label>
                    <ng-select [items]="filteredSites" bindLabel="nom" bindValue="siteId" formControlName="sites"
                        id="sites" [multiple]="true" [placeholder]="'PLACEHOLDERS.SELECT_SITE' | translate"
                        [clearable]="true" required>
                    </ng-select>
                </div>
                <div class="mb-2 toggle-container" style="flex: 1;">
                    <div class="toggle-wrapper">
                        <label class="form-check-label me-2" for="adminSites">
                            {{ 'FORM.ADMIN_SITES' | translate }}
                        </label>
                        <label class="switch">
                            <input type="checkbox" id="adminSites" formControlName="adminSites" />
                            <span class="slider round"></span>
                        </label>
                    </div>
                </div>
            </div>

            <div class="mb-2 toggle-container">
                <div class="toggle-wrapper">
                    <label class="form-check-label me-2" for="enabled">
                        {{ 'FORM.ACTIVE' | translate }}
                    </label>
                    <label class="switch">
                        <input type="checkbox" id="enabled" formControlName="enabled" />
                        <span class="slider round"></span>
                    </label>
                </div>
            </div>
        </form>
    </div>

    <div class="button-group">
        <button class="secondary-button popup-secondary-button me-2" (click)="closeDialog()">
            {{ 'BUTTONS.CANCEL' | translate }}
        </button>
        <button class="primary-button popup-primary-button" type="submit" [disabled]="userForm.invalid || isLoading" (click)="onSubmit()">
            <ng-container *ngIf="!isLoading">
                {{ 'BUTTONS.CONFIRM' | translate }}
            </ng-container>
            <ng-container *ngIf="isLoading">
                <div class="spinner-border text-light" style="width: 20px; height: 20px;"></div>
            </ng-container>
        </button>
    </div>
</div>